import { render, staticRenderFns } from "./InvoiceCustomApprovalUsersCreateEdit.vue?vue&type=template&id=6c5e4f1c&scoped=true&"
import script from "./InvoiceCustomApprovalUsersCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomApprovalUsersCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCustomApprovalUsersCreateEdit.vue?vue&type=style&index=0&id=6c5e4f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e4f1c",
  null
  
)

export default component.exports